import React from "react";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import LegalPTOSJSX from "../../components/Legal/payment-terms";

const LegalPTOS = () => {
  return (
    <>
      <Header />
      <div className="container p-5">
        <LegalPTOSJSX />
      </div>
      <Footer />
    </>
  );
};

export default LegalPTOS;
